var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLaptop == 'mobile')?_c('MobileTestScreen'):_vm._e(),(_vm.isLaptop == 'laptop')?_c('LaptopTestScreen'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }